<template>
  <a-modal
    :title="title"
    :width="800"
    :visible="visible"
    :footer="null"
    @cancel="handleCancel"
  >

    <div v-if="st===1" class="pl-60 pr-60 pt-20">
      <div class="fs-24 t-center mb-20">
        第1步：完善我的寄件信息...
      </div>
      <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form1" :rules="loginRules1">
        <a-form-model-item prop="companyName" label="公司名称">
          <a-input :disabled="true" v-model="form1.companyName" placeholder="请填写公司名称" />
        </a-form-model-item>
       
        <a-form-model-item prop="adminName" label="寄件人姓名">
          <a-input v-model="form1.adminName" placeholder="请填写寄件人姓名" />
        </a-form-model-item>
        <a-form-model-item prop="adminPhone" label="寄件人电话">
          <a-input v-model="form1.adminPhone" placeholder="请填写手机号/电话" />
        </a-form-model-item>
         <a-form-model-item prop="companyAddr" label="公司地址">
          <Addr :result.sync="form1.companyAddr" /></a-form-model-item>
        <a-row class="mt-20 mb-20">
          <a-col :offset="4">  <a-button
            type="primary"
            :loading="formLoading"
            @click="postForm1"
          >
            保存及下一步
          </a-button></a-col>
        </a-row>
      </a-form-model>
    </div>

    <div v-if="st===2" class="pl-60 pr-60 pt-20">
      <div class="fs-24 t-center mb-20">
        第2步：已默认开启一下常用快递
      </div>
      <table class="pci-table " border="1">
        <tr style="background: aliceblue;">
          <th>快递公司</th>
          <th>启用状态</th>
          <th >结算方式</th>
        </tr>
         <tr style="background: aliceblue;">
          <td>申通快递</td>
          <td >默认已开启</td>
          <td class="f-c-blue">预存无感支付</td>
        </tr>
         <tr style="background: aliceblue;">
          <td>EMS邮政</td>
          <td >默认已开启</td>
          <td class="f-c-blue">预存无感支付</td>
        </tr>
         <tr style="background: aliceblue;">
          <td>韵达快递</td>
          <td >默认已开启</td>
          <td class="f-c-blue">预存无感支付</td>
        </tr>
        <tr>
          <td>顺丰快递</td>
          <td>默认已启用</td>
          <td>线下结算</td>
        </tr>
        <tr>
          <td>中通快递</td>
          <td>默认已启用</td>
          <td>线下结算</td>
        </tr>
      </table>
      <div class="t-center mt-40 mb-20"><a-button type="primary" class="w-160" @click="$router.push('/main/manager/settlement-settings')">我知道了</a-button> <a-button type="link" @click="$router.push('/main/manager/settlement-settings')">去设置快递公司</a-button></div>
    </div>

  </a-modal>
</template>
<script>
import validate from '@framework/utils/biz-validate'
import Addr from '@/components/addr'
export default {
  components: {
    Addr
  },
  props: {
    viz: {
      type: Boolean,
      default: false
    }
  },
  data() {
    const validateEmail = (rule, value, callback) => {
      if (!validate.email.pattern.test(value)) {
        callback(new Error(validate.email.msg))
      } else {
        callback()
      }
    }
    const validateMobile = (rule, value, callback) => {
      if (!this.$utils.rules.mobileOrPhone.pattern.test(value)) {
        callback(new Error(this.$utils.rules.mobileOrPhone.msg))
      } else {
        callback()
      }
    }

    const validateAddr = (rule, value, callback) => {
      if (!value || !value.provinceCode) {
        callback(new Error('请选择省市区'))
      } else if (!value || !value.addressDetail) {
        callback(new Error('请填写详细地址'))
      } else {
        callback()
      }
    }
    return {
      title: '仅需2步，即可开通企业寄件',
      st: 1,
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      loginRules1: {
        companyAddr: [
          { required: true, trigger: 'change', validator: validateAddr }
        ],
        adminPhone: [
          { required: true, trigger: 'change', validator: validateMobile }
        ],

        // companyName: [
        //   { required: true, trigger: 'change', message: '请填写公司名称' }
        // ],
        adminName: [
          { required: true, trigger: 'change', message: '请填写寄件人姓名' }
        ],
        // adminEmail: [
        //   { required: true, trigger: 'change', validator: validateEmail }
        // ]

      },
      visible: this.viz,
      confirmLoading: false,
      form1: {
        'companyName': this.$store.state.user.company,
        'companyAddr': null,
        'adminName': '',
        'adminPhone': '',
        'adminEmail': ''
      },
      formLoading: false
    }
  },
  watch: {
    visible(n) {
      this.$emit('update:viz', n)
    },
    viz(n) {
      this.visible = n
    }
  },
  methods: {

    close() {
      this.visible = false
    },
    show() {
      this.visible = true
    },

    postForm1() {
      this.$refs.form.validate(async v => {
        if (v) {
          this.formLoading = true
          try {
            const res = await this.$http({...this.$api.addressAddDefaultAddress,origin: true}, {
              'addressDetail': this.form1.companyAddr.addressDetail,
              addressType:1,
              'areaName': this.form1.companyAddr.areaName,
              'cityName': this.form1.companyAddr.cityName,
              'provinceName': this.form1.companyAddr.provinceName,
              'areaCode': this.form1.companyAddr.areaCode,
              'cityCode': this.form1.companyAddr.cityCode,
              'provinceCode': this.form1.companyAddr.provinceCode,
              'companyName': this.form1.companyName,
              'contactEmail': this.form1.adminEmail,
              'mobile': this.form1.adminPhone,
              'contactName': this.form1.adminName
            })
            if (res) {
              this.st = 2
              // Object.assign(this.form1, {
              //   'companyName': '',
              //   'linkMan': '',
              //   'mobilePhone': '',
              //   'userName': '',
              //   'userPassword': '',
              //   'validateCode': ''
              // })
              // this.$message.success('注册成功')
              // this.$login.show()
              // setToken(res.token)
              // window.location.reload()
            }
            // setToken(res)
            // window.location.reload()
          } catch (error) {
            this.formLoading = false
          }
        }
      })
    },
    handleCancel(e) {
      this.visible = false
    }
  }
}
</script>
<style lang="scss">
.pci-table{
  width: 100%;
  text-align: center;
  // border-color: #dedede;;
  th{
    background: #dedede;
  }
  .bg-red{
    background: #ff4747;
  }
  th,td{
    width: 33.33%;
  }
}
</style>
